<template>
  <div class="row mt-md-5">
    <div class="text-center mt-4 col-12 justify-content-center">
        <h3>Validar Acceso de Alumno</h3>
        <form 
        autocomplete="off" 
        class="mb-5 row justify-content-center" 
        v-on:submit.prevent="ContestarEncuesta">
          <div 
          style="position: relative;display: inline-block;"
          class="mb-3 col-6 col-md-4 autocomplete">
            <h6 class="mt-5">Matricula</h6>
            <input
            :disabled="loading"
            type="text" 
            class="form-control text-center" 
            id="matricula" />
          </div>
          <h6 class="mt-5">Nombre del Alumno</h6>
          <div 
          style="position: relative;display: inline-block;"
          class="mb-3 col-10 col-md-6 autocomplete">
            <input 
            :disabled="loading"
            type="text" 
            class="form-control text-center" 
            id="nombre" />
          </div>
          <div class="m-3">
            <button
            :disabled="loading" 
            type="submit" 
            class="btn btn-primary">
              Contestar Encuesta
              <i 
              v-if="loading"
              class="ml-1 fas fa-spinner fa-spin"></i>
            </button>
          </div>
        </form>
      </div>
    <div class="modal" tabindex="-1" id="modal_encuesta">
      <div class="modal-dialog modal-dialog-centered">
        <div class="modal-content">
          <div class="modal-header">
            <h5 class="modal-title">Contestar encuesta</h5>
            <button type="button" class="btn-close" v-on:click="CancelarEncuesta" data-bs-dismiss="modal" aria-label="Close"></button>
          </div>
          <div class="modal-body">
            <div class="row">
              <div class="col-12">
                <h6><b>{{matricula}}</b></h6>
                <h6><b>{{nombre}}</b></h6>
              </div>
            </div>
            <div class="row ps-3 pt-4">
              <div 
              :key="index"
              class="col-12 mb-4" 
              v-for="(pregunta,index) in preguntas">
                {{pregunta.pregunta}}
                <div class="row my-3">
                  <div class="form-check col-6">
                    <input 
                    class="form-check-input" 
                    type="radio"
                    value="true"
                    v-model="pregunta.respuesta" 
                    :name="'pregunta_'+index" 
                    :id="'pregunta_si_'+index" />
                    <label class="form-check-label" :for="'pregunta_si_'+index">
                      SI
                    </label>
                  </div>
                  <div class="form-check col-6">
                    <input 
                    class="form-check-input" 
                    type="radio"
                    value="false"
                    v-model="pregunta.respuesta" 
                    :name="'pregunta_'+index" 
                    :id="'pregunta_no_'+index" />
                    <label class="form-check-label" :for="'pregunta_no_'+index">
                      NO
                    </label>
                  </div>
                </div>
              </div>
            </div>
          </div>
          <div class="modal-footer">
            <button 
            :disabled="loading_modal"
            v-on:click="CancelarEncuesta"
            class="btn btn-danger">
              Cancelar
            </button>
            <button 
            :disabled="loading_modal"
            v-on:click="EnviarEncuesta"
            class="btn btn-success">
              <i 
              v-if="loading_modal"
              class="fas fa-spinner mr-2 fa-spin"></i>
              Enviar
            </button>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
const axios = require('axios');
import {mapState} from 'vuex';
export default {
  data(){
    return {
      loading:true,
      loading_modal:false,
      matricula:'',
      nombre:'',
      modalToggle:null,
      myModal:null,
      alumnos:[],
      preguntas:[
        {
          "pregunta":"¿Has tenido tos o dolor de garganta?",
          "respuesta":false
        },
        {
          "pregunta":"¿Tiene dolor de cabeza?",
          "respuesta":false
        },
        {
          "pregunta":"¿Tiene dolor de cuerpo o malestar general?",
          "respuesta":false
        },
        {
          "pregunta":"¿Ha tenido fiebre?",
          "respuesta":false
        },
        {
          "pregunta":"¿Tiene alguna dificultad para respirar?",
          "respuesta":false
        },
        {
          "pregunta":"¿Ha tenido contacto con alguna persona con esos síntomas?",
          "respuesta":false
        },
      ],
      matriculas:[],
      nombres:[],
      currentFocus:null,
    }
  },
  methods:{
    CancelarEncuesta(){
      this.Limpiar();
      this.myModal.hide();
    },
    Limpiar(){
      var that = this;
      this.matricula='';
      this.nombre='';
      for (let index = 0; index < this.preguntas.length; index++) {
        this.preguntas[index].respuesta=false;
      }
      $(document).ready(function(){
        $('#matricula').val('');
        $('#nombre').val('');
        that.autocomplete(document.getElementById("matricula"), that.matriculas);
        that.autocomplete(document.getElementById("nombre"), that.nombres);
      });
    },
    ContestarEncuesta(){
      var that = this;
      let matricula = $('#matricula').val();
      let nombre = $('#nombre').val();
      if(matricula.length==0 && nombre.length==0){
        return;
      }
      for (let index = 0; index < this.alumnos.length; index++) {
        if(this.alumnos[index].matricula==matricula && matricula.length>0){
          this.matricula=this.alumnos[index].matricula;
          this.nombre=this.alumnos[index].displayName;
        }else if(this.alumnos[index].displayName==nombre && nombre.length>0){
          this.matricula=this.alumnos[index].matricula;
          this.nombre=this.alumnos[index].displayName;
        }
      }
      if(this.matricula.length==0 && this.nombre.length==0){
        return;
      }
      that.myModal.show(that.modalToggle);
    },
    async EnviarEncuesta(){
      let respuestas = [];
      let contesto_todas=true;
      let tiene_sintomas=false;
      for (let index = 0; index < this.preguntas.length; index++) {
        if(this.preguntas[index].respuesta==null){
          contesto_todas=false;
        }
        let respuesta=null;
        if(this.preguntas[index].respuesta=='true' || this.preguntas[index].respuesta==true){
          respuesta=true;
          tiene_sintomas=true;
        }else if(this.preguntas[index].respuesta=='false' || this.preguntas[index].respuesta==false){
          respuesta=false;
        }
        respuestas.push(respuesta);
      }
      if(!contesto_todas){swal('Debes contestar todas las preguntas','','warning');return;}
      let carreras = [];
      for (let index = 0; index < this.alumnos.length; index++) {
        if(this.alumnos[index].matricula==this.matricula && this.matricula.length>0){
          carreras=this.alumnos[index].siase_careers;
        }else if(this.alumnos[index].nombre==this.nombre && this.nombre.length>0){
          carreras=this.alumnos[index].siase_careers;
        }
      }
      
      var that = this;
      this.loading_modal=true;
      for (let index = 0; index < carreras.length; index++) {
        try {
          let response = await axios.post(process.env.URL_API+'/api/survey/sendAsGuard',
            {
              "respuestas":respuestas,
              "matricula":this.matricula,
              "clave_carrera":carreras[index].clave
            },
            {
              headers: {
                Authorization: 'Bearer ' + this.usuario.token
              }
            }
          );
          
          
          that.myModal.hide();
          if((index+1)==carreras.length){
            this.Limpiar();
            if(tiene_sintomas){
              swal('Alumno bloqueado','El alumno no puede pasar a las instalaciones','error');
            }else{
              swal('Excelente','El alumno puede pasar','success');
            }
          }

        } catch (error){
          
          if (error.response) {
            if (error.response.status==401) {
              swal('Favor de Iniciar Sesión','','warning');  
            }else if (error.response.status==403) {
              swal(error.response.data.message,'','warning');  
            }else if (error.response.status==404) {
              swal('El alumno no existe','','warning');  
            }else if (error.response.status==400) {
              swal(error.response.data.message,'','warning');  
            }else if (error.response.status==412) {
              swal(error.response.data.message,'','warning');  
            }else{
              swal('Error','Favor de intentar mas tarde','error');    
            }
          }else{
            swal('Error','Favor de intentar mas tarde','error');  
          }
          break;
        }
      }
      this.loading_modal=false;
      
    },
    autocomplete(inp, arr) {
      /*the autocomplete function takes two arguments,
      the text field element and an array of possible autocompleted values:*/
      var currentFocus;
      /*execute a function when someone writes in the text field:*/
      inp.addEventListener("input", function(e) {
          var a, b, i, val = this.value;
          /*close any already open lists of autocompleted values*/
          closeAllLists();
          if (!val) { return false;}
          currentFocus = -1;
          /*create a DIV element that will contain the items (values):*/
          a = document.createElement("DIV");
          a.setAttribute("id", this.id + "autocomplete-list");
          a.setAttribute("class", "autocomplete-items");
          /*append the DIV element as a child of the autocomplete container:*/
          this.parentNode.appendChild(a);
          /*for each item in the array...*/
          for (i = 0; i < arr.length; i++) {
            /*check if the item starts with the same letters as the text field value:*/
            if (arr[i].substr(0, val.length).toUpperCase() == val.toUpperCase()) {
              /*create a DIV element for each matching element:*/
              b = document.createElement("DIV");
              /*make the matching letters bold:*/
              b.innerHTML = "<strong>" + arr[i].substr(0, val.length) + "</strong>";
              b.innerHTML += arr[i].substr(val.length);
              /*insert a input field that will hold the current array item's value:*/
              b.innerHTML += "<input type='hidden' value='" + arr[i] + "'>";
              /*execute a function when someone clicks on the item value (DIV element):*/
                  b.addEventListener("click", function(e) {
                  /*insert the value for the autocomplete text field:*/
                  inp.value = this.getElementsByTagName("input")[0].value;
                  /*close the list of autocompleted values,
                  (or any other open lists of autocompleted values:*/
                  closeAllLists();
              });
              a.appendChild(b);
            }
          }
      });
      /*execute a function presses a key on the keyboard:*/
      inp.addEventListener("keydown", function(e) {
          var x = document.getElementById(this.id + "autocomplete-list");
          if (x) x = x.getElementsByTagName("div");
          if (e.keyCode == 40) {
            /*If the arrow DOWN key is pressed,
            increase the currentFocus variable:*/
            currentFocus++;
            /*and and make the current item more visible:*/
            addActive(x);
          } else if (e.keyCode == 38) { //up
            /*If the arrow UP key is pressed,
            decrease the currentFocus variable:*/
            currentFocus--;
            /*and and make the current item more visible:*/
            addActive(x);
          } else if (e.keyCode == 13) {
            /*If the ENTER key is pressed, prevent the form from being submitted,*/
            e.preventDefault();
            if (currentFocus > -1) {
              /*and simulate a click on the "active" item:*/
              if (x) x[currentFocus].click();
            }
          }
      });
      function addActive(x) {
        /*a function to classify an item as "active":*/
        if (!x) return false;
        /*start by removing the "active" class on all items:*/
        removeActive(x);
        if (currentFocus >= x.length) currentFocus = 0;
        if (currentFocus < 0) currentFocus = (x.length - 1);
        /*add class "autocomplete-active":*/
        x[currentFocus].classList.add("autocomplete-active");
      }
      function removeActive(x) {
        /*a function to remove the "active" class from all autocomplete items:*/
        for (var i = 0; i < x.length; i++) {
          x[i].classList.remove("autocomplete-active");
        }
      }
      function closeAllLists(elmnt) {
        /*close all autocomplete lists in the document,
        except the one passed as an argument:*/
        var x = document.getElementsByClassName("autocomplete-items");
        for (var i = 0; i < x.length; i++) {
          if (elmnt != x[i] && elmnt != inp) {
            x[i].parentNode.removeChild(x[i]);
          }
        }
      }
      /*execute a function when someone clicks in the document:*/
      document.addEventListener("click", function (e) {
          closeAllLists(e.target);
      });
    },
    async ConsultarAlumnos(){
      var that = this;
      this.loading=true;
      this.alumnos=[];
      this.matriculas=[];
      this.nombres=[];
      try {
        let response = await axios.get(process.env.URL_API+'/api/user/student?onlyToday=1',
          {
            headers: {
              Authorization: 'Bearer ' + this.usuario.token
            }
          }
        );
        this.alumnos=response.data.students;
        for (let index = 0; index < this.alumnos.length; index++) {
          this.matriculas.push(this.alumnos[index].matricula);
          this.nombres.push(this.alumnos[index].displayName);
        }
        this.loading=false;
        $(document).ready(function(){
          that.autocomplete(document.getElementById("matricula"), that.matriculas);
          that.autocomplete(document.getElementById("nombre"), that.nombres);
        });
      } catch (error){
        
        if (error.response) {
          if (error.response.status==401) {
            swal('Favor de Iniciar Sesión','','warning');  
          }else if (error.response.status==403) {
            swal('No tienes permiso para realizar esta acción','','warning');  
          }else{
            swal('Error','Favor de intentar mas tarde','error');    
          }
        }else{
          swal('Error','Favor de intentar mas tarde','error');  
        }
        
      }
      
    }
  },
  created(){
    
  },
  mounted(){
    var that = this;
    this.loading=true;
    if(this.usuario.token==null){
      this.$router.push({name:'Login'});
    }else{
      this.modalToggle = document.getElementById('modal_encuesta') // relatedTarget
      this.myModal = new bootstrap.Modal(this.modalToggle, {
        keyboard: false,
        backdrop:false
      });
      this.ConsultarAlumnos();
    }
  },
  computed:{
    ...mapState(['usuario'])
  }
}
</script>

<style>
.bg-uanl{
  background: #004A8F !important;
  color: #ffffff !important;
}
.modal-open {
   background-color: gray;
}
.autocomplete-items {
  position: absolute;
  border: 1px solid #d4d4d4;
  border-bottom: none;
  border-top: none;
  z-index: 99;
  /*position the autocomplete items to be the same width as the container:*/
  top: 100%;
  left: 0;
  right: 0;
}
.autocomplete-items div {
  padding: 10px;
  color: black;
  cursor: pointer;
  background-color:white;
  border-bottom: 1px solid #d4d4d4;
}
.autocomplete-items div:hover {
  /*when hovering an item:*/
  background-color: #e9e9e9;
}
.autocomplete-active {
  /*when navigating through the items using the arrow keys:*/
  background-color: DodgerBlue !important;
  color: #ffffff;
}
</style>



// WEBPACK FOOTER //
// src/components/CEC.vue